import React from "react";

import theme from "config/theme";

import Icon from "components/Icon";

import { Wrapper, Date, Title, Inner, Image, PlayButton } from "./styles";

const Video = ({ content, isFeatured }) => {
  const { snippet } = content;

  const date = new window.Date(snippet.publishedAt);

  const day = date.toLocaleString("en-GB", { day: "2-digit" });
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.toLocaleString("en-GB", { year: "2-digit" });

  const publishedAt = `${day} ${month}, ${year}`;

  if (!content.id) {
    return null;
  }

  return (
    <Wrapper
      href={`https://www.youtube.com/watch?v=${snippet.resourceId.videoId}&list=${snippet.playlistId}`}
      target="_blank"
    >
      <Image
        height="100%"
        placeholder="play"
        src={snippet.thumbnails.medium.url}
        bg={theme.color.teal}
      />
      <Inner>
        <Date>{publishedAt}</Date>
        <Title
          isFeatured={isFeatured}
          dangerouslySetInnerHTML={{ __html: snippet.title }}
        />
        <PlayButton shade="primary" isFeatured={isFeatured}>
          <Icon icon="play" color="white" />
        </PlayButton>
      </Inner>
    </Wrapper>
  );
};

export default Video;
